import type { Route } from "./+types/course-exercises";
import Page from "../pages/CourseExercisesPage";
import { pageMeta } from "../lib/meta";
import { breadcrumbSchema, SITE_URL } from "../components/content/SEO/SEO";
import { content, type CourseDetail } from "../lib/content";

export async function loader({ params }: Route.LoaderArgs): Promise<{ course: CourseDetail | null }> {
  try {
    const course = await content.course(params.slug);
    return { course };
  } catch {
    return { course: null };
  }
}
export function meta({ data, params }: Route.MetaArgs) {
  const course = data?.course;
  const title = course ? `${course.title} exercises` : "Course exercises";
  // "Refactoring" and "one per module" are true of clean-code-mastery and of
  // nothing else, so the generic description no longer asserts either.
  const description = course
    ? `Hands-on coding exercises for ${course.title}, each with a starter, a test suite and a reference solution.`
    : "Hands-on coding exercises with a starter, a test suite and a reference solution.";
  const jsonLd = course
    ? [
        breadcrumbSchema([
          { name: "Home", url: SITE_URL },
          { name: "Courses", url: `${SITE_URL}/courses` },
          { name: course.title, url: `${SITE_URL}/courses/${params.slug}` },
          { name: "Exercises", url: `${SITE_URL}/courses/${params.slug}/exercises` },
        ]),
      ]
    : undefined;
  return pageMeta({ title: `${title} | Gazar`, description, path: `/courses/${params.slug}/exercises`, jsonLd });
}
export default function R({ loaderData }: Route.ComponentProps) { return <Page course={loaderData.course} />; }
